import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { gql } from '@apollo/client';

// Default GraphQL endpoint
const DEFAULT_ENDPOINT = 'http://localhost:10212/graphql';

// Get the endpoint from environment variable or use default
const endpoint = import.meta.env.VITE_WORDPRESS_API_URL || DEFAULT_ENDPOINT;

// Log the endpoint for debugging
console.log('WordPress GraphQL endpoint:', endpoint);

// Error handling link
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.error('GraphQL Errors:', graphQLErrors);
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
    });
  }
  if (networkError) {
    console.error('Network Error:', networkError);
  }
});

// Create HTTP link with CORS configuration
const httpLink = createHttpLink({
  uri: endpoint,
  credentials: 'omit',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  fetchOptions: {
    mode: 'cors',
  }
});

// Create Apollo Client
export const wpClient = new ApolloClient({
  link: from([errorLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});

// Helper function to check if WordPress is accessible
export const checkConnection = async (): Promise<boolean> => {
  try {
    console.log('Checking WordPress connection...');
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      mode: 'cors',
      credentials: 'omit',
      body: JSON.stringify({
        query: `
          query {
            disabilityHacks(first: 1) {
              nodes {
                databaseId
              }
            }
          }
        `
      })
    });

    if (!response.ok) {
      console.error('WordPress connection failed:', response.status, response.statusText);
      return false;
    }

    const data = await response.json();
    console.log('WordPress connection response:', data);
    
    if (data.errors) {
      console.error('WordPress GraphQL errors:', data.errors);
      return false;
    }

    return !!data?.data?.disabilityHacks?.nodes?.length;
  } catch (error) {
    console.error('Error checking WordPress connection:', error);
    return false;
  }
};

// Helper functions for endpoint management
export const getStoredWPEndpoint = (): string => {
  return localStorage.getItem('wpEndpoint') || endpoint;
};

export const updateWPEndpoint = (newEndpoint: string): void => {
  localStorage.setItem('wpEndpoint', newEndpoint);
  window.location.reload();
};

// Get custom field configuration
export const getCustomFields = () => {
  return {}; // Return empty object for now, can be expanded later if needed
};

const CHECK_CONNECTION = gql`
  query CheckConnection {
    disabilityHacks(first: 1) {
      nodes {
        databaseId
      }
    }
  }
`; 